(()=>{
  const d=document.querySelector('dialog.pdp-viewer');
  if(!d)return;
  const img=d.querySelector('.pdp-viewer__img');
  if(!img)return;
  const cache={};
  const FALLBACK='#d3d4d5';
  /* read the photo's left edge from top to bottom and build a matching vertical gradient */
  const sample=src=>{
    if(cache[src])return Promise.resolve(cache[src]);
    return fetch(src,{mode:'cors'}).then(r=>r.blob()).then(b=>createImageBitmap(b)).then(bmp=>{
      const N=12,c=document.createElement('canvas');
      c.width=4;c.height=N*4;
      const x=c.getContext('2d',{willReadFrequently:true});
      x.drawImage(bmp,0,0,Math.max(1,bmp.width*0.02),bmp.height,0,0,4,N*4);
      const stops=[];
      for(let i=0;i<N;i++){
        const p=x.getImageData(0,i*4+2,4,1).data;
        let r=0,g=0,b=0;
        for(let k=0;k<4;k++){r+=p[k*4];g+=p[k*4+1];b+=p[k*4+2];}
        stops.push('rgb('+Math.round(r/4)+','+Math.round(g/4)+','+Math.round(b/4)+') '+Math.round(i/(N-1)*100)+'%');
      }
      return (cache[src]='linear-gradient(to bottom,'+stops.join(',')+')');
    });
  };
  const sync=()=>{
    const src=img.currentSrc||img.getAttribute('src')||'';
    if(!src)return;
    sample(src).then(g=>{
      if((img.currentSrc||img.getAttribute('src'))===src)d.style.setProperty('--vbg',g);
    },()=>d.style.setProperty('--vbg',FALLBACK));
  };
  new MutationObserver(sync).observe(img,{attributes:true,attributeFilter:['src','srcset']});
  new MutationObserver(sync).observe(d,{attributes:true,attributeFilter:['open']});
  img.addEventListener('load',sync);
  sync();
})();
